<template>
  <div
    class="fixed top-0 left-0 bottom-0 right-0 flex justify-center items-center px-6 text-black-100 z-50"
    style="background-color: rgba(255,255,255,0.5);"
  >
    <div class="z-10 w-10 animate-spin">
      <img src="/img/wizard/progress.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "WizardProgress",
};
</script>

<style lang="scss" scoped>
.animate-spin {
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
